module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outerBlock"
  }, [_c('div', {
    staticClass: "container-fluid mission"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('Enjoy  youself while contributing to nature conservation')))]), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.t('Our mission is to bring you on an adventure in a sustainable relationship with nature')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('We promote good environmental practices with the comunity')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('1% of our profits will be donated to nature conservancy projects')))]), _vm._v(" "), _c('div', {
    staticClass: "actions text-xs-center"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": ("/" + _vm.language + "/about-us")
    }
  }, [_vm._v(_vm._s(_vm.t('Find out more')))])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f657b1f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f657b1f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Mission.vue
// module id = 809
// module chunks = 3